import { createUseStyles } from 'react-jss';
import bg from '../../assets/images/bg.png';

export default createUseStyles({
  start: {
    backgroundImage: `url(${bg})`,
    backgroundSize: 'cover',
    background: 'linear-gradient(148.8deg, #95DDF4 -149.76%, rgba(149, 221, 244, 0.08) 32.26%)',
  },
});
